/*
 * Saliwa PDP — "You may also like" enhancements
 * - Makes related-product cards that are NOT already <a> links clickable,
 *   navigating to /products/<handle> (handle = first word of the product name).
 * - Points "Shop all mirrors" and the "Mirrors" breadcrumb placeholder to /products.
 * Exposed as window.SaliwaEnhanceXsell(doc) so the Lumina iframe PDP can reuse it.
 */
(function () {
  function handleFromName(name) {
    var first = (name || '').trim().split(/\s+/)[0].toLowerCase();
    return /^[a-z]+$/.test(first) ? '/products/' + first : null;
  }

  function enhance(doc) {
    doc = doc || document;

    // Related-product cards rendered as <article> (no anchor wrapper) → make clickable.
    doc.querySelectorAll('.xsell article.product-card').forEach(function (card) {
      if (card.getAttribute('data-xsell-linked')) return;

      var quickAdd = card.querySelector('.quick-add');
      var heading = card.querySelector('h3');
      var name = (quickAdd && quickAdd.getAttribute('data-name')) ||
                 (heading && heading.textContent) || '';
      var url = handleFromName(name);
      if (!url) return;

      card.setAttribute('data-xsell-linked', '1');
      card.style.cursor = 'pointer';
      card.addEventListener('click', function (event) {
        // Let the Quick Add button (and any real links) keep their own behaviour.
        if (event.target.closest('.quick-add, button, a')) return;
        window.location.href = url;
      });
    });

    // "Shop all mirrors" → /products
    doc.querySelectorAll('.xsell .head-link').forEach(function (link) {
      link.setAttribute('href', '/products');
      link.setAttribute('target', '_top');
    });

    // Breadcrumb "Mirrors" placeholder (href="#") → /products
    doc.querySelectorAll('.crumbs a, .breadcrumb a').forEach(function (a) {
      if (a.getAttribute('href') === '#' && a.textContent.trim().toLowerCase() === 'mirrors') {
        a.setAttribute('href', '/products');
      }
    });
  }

  window.SaliwaEnhanceXsell = enhance;

  if (document.readyState !== 'loading') {
    enhance(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  }
})();
